import { createFileRoute } from "@tanstack/react-router";

import { OrderFormPage } from "../../../features/orders/order-form-page";

export const Route = createFileRoute("/_app/orders/new")({ component: () => <OrderFormPage /> });
